<div class="subheader with-padding flgrow" style="position: relative;">
    <div class="row">
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8 maxw600">
            <div class="d-flex">
                <div class="flex-grow-1">
                    <div class="input-group">
                        <input class="form-control" type="text" name="searchTerm"
                            placeholder="{{ 'lblQuicksearch' | translate }}" [(ngModel)]="searchTerm"
                            autocomplete="off" (keyup.enter)="onQuickSerch()"/>
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary" (click)="onQuickSerch()">
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="ml-2 advanced-search-box">
                    <button type="button" class="btn btn-primary" (click)="onSearch()" aria-label="Center Align">
                        <i class="fa fa-search-plus" aria-hidden="true"></i>
                    </button>
                    <div class="searchbox card fix rt" *ngIf="isAdvanceSearch">
                        <div class="form-row mt-3 mb-4">
                            <div class="col" *ngIf="isShowDMSStatus">
                                <label translate>lblAppointmentStatus</label>
                                <select class="form-control" [(ngModel)]="appointmentRequestModel.appointmentStatusId"
                                    name="id">
                                    <option selected translate [ngValue]=null>lblSelectStatus</option>
                                    <option *ngFor="let status of appointmentstatusList" [ngValue]="status.id">
                                        {{status.name}}
                                    </option>
                                </select>
                            </div>
                            <div class="col">
                                <label translate>lblWorkOrderStatus</label>
                                <select class="form-control" [(ngModel)]="appointmentRequestModel.workOrderStatusId"
                                    name="id">
                                    <option selected translate [ngValue]=null>lblSelectStatus</option>
                                    <option *ngFor="let workOrderStatus of workOrderStatusList"
                                        [ngValue]="workOrderStatus.id">
                                        {{workOrderStatus.status}}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class='col-12'>
                                <label translate>lblBookedDate</label>
                                <div class="date">
                                    <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                                    [(ngModel)]="bookingDate" required />
                                </div>
                            </div>
                            <div class='col-12'>
                                <label translate>lblCreatedDate</label>
                                <div class="date">
                                    <input bsDaterangepicker name="CreatedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                                    [(ngModel)]="createdDate" required />
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col text-right">
                                <button type="submit" (click)="AdvanceSearchSubmit()" class="btn btn-primary mr-sm-2"
                                    translate>lblApply
                                </button>
                                <button (click)="onReset()" class="btn btn-outline-tertiary mr-sm-2" translate>lblReset
                                </button>
                                <button (click)="onClose()" class="btn btn-outline-tertiary mr-sm-2" translate>lblClose
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 relative flmid pl-4" *ngIf="dealers && dealers.length > 0;">
            <div class="lbl-info" style="width: 100%;">
                <ng-select class="" (change)="onDealerChange()" [(ngModel)]="selectedDealer" name="dealerId"
                    placeholder="{{ 'lblSelectDealer' | translate }}">
                    <ng-option *ngFor="let dealer of dealers" [value]="dealer.dealerId">
                        {{dealer.name}}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div
            class="col-xl-6 col-lg-6 col-md-12 relative flmid mt-3 mt-lg-0 justify-content-md-end justify-content-lg-start">
            <button type="submit" (click)="onClickChangeView(false)"
                [ngClass]="isTodayViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'" class="mr-sm-2"
                translate>lblSATodayView
            </button>
            <button (click)="onClickChangeView(true)"
                [ngClass]="isWeekViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'" class=""
                translate>lblSAWeekView
            </button>
            <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" aria-label="Center Align"
                (click)='refresh()'>
                <em class="fas fa-sync fa-lg"></em>
            </a>
        </div>
    </div>
</div>
<!-- Main status Main List -->
<div class="container prel">


    <div class="card no-bgShadow">
        <div class="overflow-auto scroll-height">
            <div class="card-body relative">

                <div class="topfix">


                    <div class="d-flex text-center status-header mb-2">
                        <div class="px-2 align-self-center min-w-275" [ngClass]="zoomClass" *ngFor="let title of statusData;">

                            <div class="status-title status-customer-arrived d-flex align-items-center justify-content-center"
                                [ngClass]="{'status-planned': translate.instant(title.key) == translate.instant('lblPlanned'),
                                                'status-customer-arrived': translate.instant(title.key) == translate.instant('lblCarArrived'),
                                                'status-started': translate.instant(title.key) === translate.instant('lblMechanicStarted'),
                                                'status-done': translate.instant(title.key) === translate.instant('lblMechanicDone'),
                                                'status-finished': translate.instant(title.key) === translate.instant('lblFinished'),
                                                'status-ready': translate.instant(title.key) === translate.instant('lblReady'),
                                                'status-onhold': translate.instant(title.key) === translate.instant('lblOnHold')}">
                                {{title.key | translate}}
                                ({{title.totalCount}})

                            </div>
                        </div>
                    </div>
                </div>

                <div class="">
                    <ul class="d-flex scrollbar" *ngIf="statusData && statusData?.length>0">
                        <li class="px-2 min-w-275" [ngClass]="zoomClass" *ngFor="let title of statusData;let i=index;">
                            <div [ngClass]="{'status-planned': translate.instant(title.key) == translate.instant('lblPlanned'),
                          'status-customer-arrived': translate.instant(title.key) == translate.instant('lblCarArrived'),
                          'status-started': translate.instant(title.key) === translate.instant('lblMechanicStarted'),
                          'status-done': translate.instant(title.key) === translate.instant('lblMechanicDone'),
                          'status-finished': translate.instant(title.key) === translate.instant('lblFinished'),
                          'status-ready': translate.instant(title.key) === translate.instant('lblReady'),
                          'status-onhold': translate.instant(title.key) === translate.instant('lblOnHold')}">
                                <ng-container *ngIf="(title.subList === null); else notValues">
                                    <div class="car-box-pop-details" *ngFor="let Final of title.workOrderList;"
                                        (click)="editAppointmentCallForClick(Final)"
                                        (dblclick)="updateStatusForDblClick(mymodal,Final)">

                                        <div
                                            class="card-header border-bottom p-2 d-flex align-items-center justify-content-between">
                                            <div class="d-flex align-items-center">
                                                <div class="lp-outer">
                                                    <div class="licplate LPNo d-flex p-0"><span
                                                            class="icn-flag flag-NO"></span>{{Final.licensePlate}}
                                                    </div>
                                                </div>
                                                <div class="imgWid">
                                                    <ng-container>
                                                        <img af-brand-logo [data-code]="Final.brand" data-type="BRAND"
                                                            class="{{Final.brand.name}}-icon common"
                                                            [title]="Final.brandCode" class="brandicon" alt="img" />
                                                    </ng-container>
                                                </div>
                                                <div *ngIf="Final.isCustomerWaiting === true" class="d-flex align-items-center">
                                                    <em class="fas fa-clock mr-2"></em>
                                                </div>
                                            </div>
                                            <div class="text-right mr-1 flex-grow-1">
                                                <div class="fs-14px lh-14px d-block">#{{Final.workOrder}}</div>
                                            </div>
                                        </div>
                                        <div
                                            class="card-sub-header status-text py-2 px-2 d-flex justify-content-between align-items-center">
                                            <span class="semibold">Status:</span>
                                            <div class="fs-13px bold lh-14px d-block text-normalcase status-column"
                                                [ngClass]="{'status-planned': translate.instant(title.key) == translate.instant('lblPlanned'),
                                                            'status-customer-arrived': translate.instant(title.key) == translate.instant('lblCarArrived'),
                                                            'status-started': translate.instant(title.key) === translate.instant('lblMechanicStarted'),
                                                            'status-done': translate.instant(title.key) === translate.instant('lblMechanicDone'),
                                                            'status-finished': translate.instant(title.key) === translate.instant('lblFinished'),
                                                            'status-ready': translate.instant(title.key) === translate.instant('lblReady'),
                                                            'status-onhold': translate.instant(title.key) === translate.instant('lblOnHold')}">
                                                <div class="d-flex flex-row p-1 mb-1">
                                                    <span class="color-box"
                                                        [style.background-color]="Final.workOrderStatusColor"></span>
                                                    <span class="status-name">{{Final.workOrderStatus}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body p-0">
                                            <ul class="list-group list-group-flush">
                                                <li class="list-group-item p-2 d-flex align-items-center"><em
                                                        class="fas icon-clockic mr-2 fs-16px"></em>
                                                    {{Final.bookedDate}} </li>
                                                <li class="list-group-item p-2 d-flex align-items-center"><em
                                                        class="fas icon-business-m mr-2 fs-16px"></em>
                                                    {{Final.dealer}} - {{Final.customerName}} </li>
                                                    <li *ngFor="let mech of Final.mechanicList" class="list-group-item p-2 d-flex justify-content-between px-1" tooltipClass="my-tooltip"ngbTooltip="{{mech}} " container="body"><em
                                                        class="fas icon-mechanic mr-2 fs-16px"></em>
                                                        <span class="text-truncate" style="max-width: 230px;margin-right: auto;"> {{mech}} </span>
                                                   </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>

                                <!-- Sub Status Sublist -->
                                <ng-template #notValues>
                                    <div *ngFor="let Final of title.subList; let x = index">
                                        <div class="col-12 p-0" [ngClass]="{'active': isCollapsed[x + '_' + Final.key]}">
                                            <button class="button mb-2 w-100 status-block status-title"
                                                [ngClass]="{'lightgreen': translate.instant(Final.key) == translate.instant('lblInvoiceReady'),
                                                'green': translate.instant(Final.key) === translate.instant('lblInvoicedkey'),
                                                'darkgreen': translate.instant(Final.key) === translate.instant('lblClosed'),
                                                'status-cancelled': translate.instant(Final.key) === translate.instant('lblCancelled'),
                                                'status-onhold': translate.instant(Final.key) === translate.instant('lblOnHold')}" 
                                                (click)="toggleCollapse(x, Final.key)">
                                                {{ Final.key | translate }} ({{Final.totalCount}})
                                                <em class="fas ml-2"
                                                    [ngClass]="!isCollapsed[x + '_' + Final.key] ? 'fa-chevron-right' : 'fa-chevron-down'">
                                                </em>
                                            </button>
                                        </div>
                                        <div class="">
                                            <div class="pb-2" [ngbCollapse]="!isCollapsed[x + '_' + Final.key]"
                                                [ngClass]="{ 'status-ready': translate.instant(Final.key) == translate.instant('lblInvoiceReady'),
                                                'status-invoiced': translate.instant(Final.key) === translate.instant('lblInvoicedkey'),
                                                'status-key-pickedup': translate.instant(Final.key) === translate.instant('lblClosed'),
                                                'status-cancelled': translate.instant(Final.key) === translate.instant('lblCancelled'),
                                                'status-onhold': translate.instant(Final.key) === translate.instant('lblOnHold')
                                                }">
                                                <div class="car-box-pop-details" 
                                                
                                                    *ngFor="let order of Final.workOrderList"
                                                    (click)="editAppointmentCallForClick(order)"
                                                    (dblclick)="updateStatusForDblClick(mymodal,order)">
                                                    <div
                                                        class="card-header border-bottom p-2 d-flex align-items-center justify-content-between">
                                                        <div class="d-flex align-items-center">
                                                            <div class="lp-outer">
                                                                <div class="licplate LPNo d-flex p-0"><span
                                                                        class="icn-flag flag-NO"></span>{{order.licensePlate}}
                                                                </div>
                                                            </div>
                                                            <div class="imgWid">
                                                                <ng-container>
                                                                    <img af-brand-logo [data-code]="order.brand" data-type="BRAND"
                                                                        class="{{order.brand.name}}-icon common"
                                                                        [title]="order.brandCode" class="brandicon"
                                                                        alt="img" />
                                                                </ng-container>
                                                            </div>
                                                        </div>
                                                        <div class="text-right mr-1 flex-grow-1">
                                                            <div class="fs-14px lh-14px d-block">#{{order.workOrder}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="card-sub-header status-text py-2 px-2 d-flex justify-content-between align-items-center">
                                                        <span class="semibold">Status:</span>
                                                        <div class="fs-13px bold lh-14px d-block text-normalcase status-column"
                                                            [ngClass]="{'status-ready': Final.key == 'Invoice ready',
                                                            'status-invoiced': translate.instant(Final.key) === translate.instant('lblInvoicedkey'),
                                                            'status-key-pickedup': translate.instant(Final.key) === translate.instant('lblClosed'),
                                                            'status-cancelled': translate.instant(Final.key) === translate.instant('lblCancelled'),
                                                            'status-onhold': translate.instant(Final.key) === translate.instant('lblOnHold')
                                                            }">
                                                            <div class="d-flex flex-row p-1 mb-1">
                                                                <span class="color-box"
                                                                    [style.background-color]="order.workOrderStatusColor"></span>
                                                                <span
                                                                    class="status-name">{{order.workOrderStatus}}</span>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div class="card-body p-0">
                                                        <ul class="list-group list-group-flush">
                                                            <li class="list-group-item p-2 d-flex align-items-center">
                                                                <em class="fas icon-clockic mr-2 fs-16px"></em>
                                                                {{order.bookedDate}} </li>
                                                            <li class="list-group-item p-2 d-flex align-items-center">
                                                                <em class="fas icon-business-m mr-2 fs-16px"></em>
                                                                {{order.dealer}} - {{order.customerName}} </li>
                                                                <li *ngFor="let mech of order.mechanicList" class="list-group-item p-2 d-flex justify-content-between px-1" tooltipClass="my-tooltip"ngbTooltip="{{mech}} " container="body"><em
                                                                   class="fas icon-mechanic mr-2 fs-16px"></em>
                                                                  <span class="text-truncate" style="max-width: 230px;margin-right: auto;"> {{mech}} </span>
                                                               </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>

                            </div>
                        </li>
                    </ul>

                </div>
            </div>
        </div>
    </div>

</div>


<ng-template #mymodal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblUpdateWOStatus</h4>
        <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
            (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row" *ngIf="isOpenByOtherUser">
            <div class="col-12">
                <div class="alert alert-warning font18 text-center p-2 mb-2">{{isOpenByOtherUserMsg}}</div>
            </div>
        </div>
        <div class="">
            <div class="row" *ngIf="updateAppointmentStatusModel">
                <div class="col-6">
                    <div class="af-form-group">
                        <label translate>lblCustomerName</label>
                        <div class="lbl-info">{{updateAppointmentStatusModel.customerName}}</div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="af-form-group">
                        <label translate>lblWoNo</label>
                        <div class="lbl-info">{{updateAppointmentStatusModel.WOnumber}}</div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="af-form-group">
                        <label translate>lblDealerName</label>
                        <div class="lbl-info">{{updateAppointmentStatusModel.dealerName}}</div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="af-form-group">
                        <label translate>lblWoStatus</label>
                        <div class="lbl-info">
                            <span class="color-box"
                                [style.background-color]="updateAppointmentStatusModel.WOstatusColor"></span> &nbsp;
                            <span>{{updateAppointmentStatusModel.WOstatus}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="af-form-group">
                        <label translate>lblRegNumber</label>
                        <div class="lbl-info flmid">
                            <div class="licplate LPNo d-flex">
                                <span class="icn-flag"></span> {{updateAppointmentStatusModel.licensePlate}}
                            </div>
                            <div class="imgWid">
                                <img af-brand-logo [data-code]="updateAppointmentStatusModel.brandImg" data-type="BRAND" class="brandicon" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <label translate>lblNewWOStatusTo</label>
                    <div class="lbl-info">
                        <ng-select [(ngModel)]="SelectedStatus" [ngModelOptions]="{standalone: true}"
                            placeholder="{{ 'lblSelectStatus' | translate }}"  (change)="onStatusChange()">
                            <ng-option *ngFor="let status of statusList" [value]="status.id">
                                {{status.name}}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="col-6 mt-3">
                    <div class="af-form-group">
                        <label translate>lblModel</label>
                        <div class="lbl-info">{{updateAppointmentStatusModel.model}}</div>
                    </div>
                </div>

                <div class="col-6 mt-3">
                    <div class="af-form-group">
                        <label translate>lblAppointmentStatus</label>
                        <div class="lbl-info">
                            <span class="color-box"
                                [style.background-color]="updateAppointmentStatusModel.appointmnetStatusColor"></span>
                            &nbsp;
                            <span>{{updateAppointmentStatusModel.appointmentStatus}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="af-form-group" *ngIf="isDisplayInvoice">
                        <div class="form-check pl-0">
                            <label translate>lblFinalInvoice</label>
                            <div class="lbl-info relative km-block">
                              <input type="text" class="form-control text-right"  id="name"
                                maxlength="10" required #name="ngModel"
                                [ngModel]="InvoicePrice | toNumber | number: '1.2-2'" pattern="^[\d,.\s]+$" (blur)="onBlur($event)"
                                 />
                            </div>
                            <div *ngIf="name.invalid && (name.dirty || name.touched)"
                            class="help-block mt-1 text-danger">
                              <div  class="help-block mt-1 text-danger"
                              translate>
                              lblPleaseEnterTheValidValue
                            </div>
                            </div>
                          </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="af-form-group">
                        <label translate>lblBookedDate</label>
                        <div class="lbl-info">{{updateAppointmentStatusModel.bookDate}}</div>
                    </div>
                </div>


            </div>
        </div>

    </div>
    <div class="modal-footer">
        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2" translate (click)="updateStatus()"
                *ngIf="updateAppointmentStatusModel && updateAppointmentStatusModel.WOstatusId !== 10"
                aria-label="Center Align" [disabled]="!SelectedStatus || isOpenByOtherUser">lblUpdate</button>
            <button (click)="modal.dismiss('Cross click')" class="btn btn-secondary" aria-label="Center Align"
                translate>lblCancel</button>
        </div>
    </div>
</ng-template>

<svg display="none">
    <symbol width="18" height="18" viewBox="0 0 24 24" id="customer-icn">
        <path d="M20.6,20.9c0.1,0,0.2-0.1,0.2-0.2c-0.1-3.9-2.8-7.2-6.3-8.1c-0.2-0.1-0.2-0.3-0.1-0.4C15.9,11.4,17,9.8,17,8
      c0-2.7-2.2-4.8-4.8-4.8s-5,2.1-5,4.8c0,1.9,1,3.4,2.6,4.2c0.2,0.1,0.1,0.4-0.1,0.4c-3.6,1-6.3,4.2-6.4,8.1c0,0.1,0.1,0.2,0.2,0.2H10
      C10.1,20.9,20.6,20.9,20.6,20.9z"></path>
    </symbol>

    <symbol width="18" height="18" viewBox="0 0 24 24" id="dealer-icn">
        <g>
            <path class="st0" d="M19.3,13.5l-0.9-0.3l-3.9-1.4l-0.8,10.9l-1.5-8.3c0.3-0.3,0.6-0.8,0.6-1.2c0-0.6-0.5-0.6-0.9-0.6
                c-0.5,0-0.9,0-0.9,0.6c0,0.5,0.2,0.9,0.6,1.2l-1.2,8.3L9.8,11.8l-4.1,1.4l-0.9,0.3C4.3,13.7,4,14.3,4,14.9v5.8c0,1,0.9,2,2,2h12.5
                c1,0,2-0.9,2-2v-5.8C20.2,14.2,19.9,13.6,19.3,13.5z" />
            <path class="st0" d="M9.2,8c0.1,0.2,0.1,0.4,0.1,0.5c0.1,0.3,0.2,0.7,0.5,1c0.7,0.9,1.7,1.3,2.8,1c0.3-0.1,0.8-0.2,1-0.5
                c0.7-0.5,1-1.2,1.2-2.1C15,7.7,15.3,7.3,15.5,7c0.2-0.5,0.3-1-0.1-1.4l0,0c0,0,0.7-2.8-1-3c0-0.1-0.1-0.3-0.2-0.5
                c-1.3-1.5-4.5-0.5-5,1.4C8.7,4.3,8.7,5,8.9,5.6C8.9,5.6,7.8,6.4,9.2,8z" />
        </g>
    </symbol>
    <symbol width="18" height="18" viewBox="0 0 24 24" id="mechanic-icn">
        <g>
            <path class="st0" d="M13.6,19.2c-0.1,0-0.2,0-0.3,0.1c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1
                c0.2-0.2,0.2-0.5,0-0.7C13.8,19.2,13.7,19.2,13.6,19.2z" />
            <path class="st0" d="M14.6,20.7c-0.3,0.3-0.6,0.4-1,0.4s-0.8-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1s0.2-0.8,0.4-1l4.2-4.2
                c-0.8-0.6-1.7-0.9-2.8-1c0,1-1.6,1.9-3.5,1.9S7,14.6,7,13.5c-2.9,0.3-5.2,2.7-5.2,5.7c0,3.2,2.6,3.2,5.7,3.2h5.9
                c3.2,0,5.7,0,5.7-3.2c0-0.9-0.2-1.7-0.6-2.5L14.6,20.7z" />
            <path class="st0" d="M10.5,13.2c-1.9,0-3.5-2.1-3.8-4.8H6.2c0.3,3.1,2.1,5.5,4.3,5.5s4-2.4,4.3-5.5h-0.5
                C14.1,11.1,12.5,13.2,10.5,13.2z" />
            <path class="st0"
                d="M6,7.7h9.1c0.4,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6h-0.2c0-1.7-1-3.2-2.4-3.9l-0.4,2c0,0.2-0.2,0.3-0.3,0.3
                c0,0,0,0-0.1,0c-0.2,0-0.3-0.2-0.3-0.4l0.4-2.3c-0.2-0.2-0.4-0.4-0.7-0.4H9.9C9.6,1.8,9.3,2,9.2,2.2l0.4,2.3c0,0.2-0.1,0.4-0.3,0.4
                c0,0,0,0-0.1,0C9.1,4.9,9,4.8,8.9,4.6l-0.4-2C7.1,3.3,6.2,4.7,6.2,6.4H6C5.6,6.4,5.4,6.7,5.4,7C5.4,7.4,5.6,7.7,6,7.7z" />
            <path class="st0" d="M21.7,13.1l-1.1,1.1h-0.9L19,13.6v-0.9l1.1-1.1l-0.5-0.5c-0.6,0-1.2,0.3-1.6,0.7c-0.7,0.7-0.9,1.7-0.6,2.6
                L12.9,19c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3l4.6-4.6c0.3,0.1,0.6,0.2,0.8,0.2
                c0.6,0,1.2-0.2,1.7-0.7c0.4-0.4,0.7-1,0.7-1.6L21.7,13.1z M13.9,20c-0.1,0.1-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1
                c-0.2-0.2-0.2-0.5,0-0.7c0.1-0.1,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1C14.1,19.5,14.1,19.8,13.9,20z" />
        </g>
    </symbol>
    <symbol width="18" height="18" viewBox="0 0 24 24" id="date-icn">
        <path class="st0" d="M5.6,2.3v1.8H3.7C3.2,4.1,2.8,4.5,2.8,5v15.6c0,0.5,0.4,0.9,0.9,0.9h16.6c0.5,0,0.9-0.4,0.9-0.9V5.1
		c0-0.5-0.4-0.9-0.9-0.9h-1.8V2.3h-2.8v1.8H8.3V2.3H5.6z M4.6,9.7h14.7v10.1H4.6V9.7z M5.6,10.6v3.7h3.7v-3.7H5.6z M10.2,10.6v3.7
		h3.7v-3.7H10.2z M14.8,10.6v3.7h3.7v-3.7H14.8z M5.6,15.2v3.7h3.7v-3.7H5.6z M10.2,15.2v3.7h3.7v-3.7H10.2z M14.8,15.2v3.7h3.7
		v-3.7H14.8z" />
    </symbol>


</svg>
